<div class="card-container" [ngStyle]="{'padding': !showFocus() ? '10px 16px' : '10px 10px'}">
  @if(!showFocus()){
    @if(data()?.type?.icon){
      <div class="card-icon">
        <mat-icon style="color:#0a7ea4" [matTooltip]="data()?.type?.name">{{data()?.type?.icon}}</mat-icon>
      </div>  
    }
    
    <div class="card-content">
      <div class="card-title">
        <mat-checkbox 
          [checked]="data()?.completed"
          (change)="onCheckboxChange($event)"
          (click)="onCheckboxClick($event)">
        </mat-checkbox>
        <span class="title-text" [ngClass]="{ 'completed': data()?.completed == true }">{{data()?.title}}</span>
      </div>
      <div class="card-details">
        <span
          [ngClass]="{
            'overdue-date': isOverdue(data()?.startDate, data()?.allDay) && !data()?.completed,
            'today-date': isToday(data()?.startDate) && !isOverdue(data()?.startDate, data()?.allDay) && !data()?.completed
          }"
        >{{data()?.startDate | customDate}} </span>
        <span class="user">{{data()?.lead?.fullName}}</span>

        @if(data()?.merged_from_lead_id){
          <span class="merged-badge">
            <mat-icon class="merged-icon">merge_type</mat-icon>
            Merged
          </span>
        }
      </div>
    </div>

    <!-- Appointment Status Badges - Right Side (Full View) -->
    @if(data()?.type?.is_appointment && (data()?.attendanceStatus || data()?.reschedule_count > 0 || getOutcome())){
      <div class="appointment-badges">
        @if(data()?.attendanceStatus){
          <span class="status-badge" [ngClass]="getStatusClass(data()?.attendanceStatus)">
            {{formatStatus(data()?.attendanceStatus)}}
          </span>
        }
        @if(getOutcome()){
          <span class="outcome-badge" [matTooltip]="'Outcome: ' + getOutcome()?.name">
            {{getOutcome()?.name}}
          </span>
        }
        @if(data()?.reschedule_count > 0){
          <span class="reschedule-badge" matTooltip="Rescheduled {{data()?.reschedule_count}} time(s)">
            <mat-icon class="mini-icon">update</mat-icon>
            {{data()?.reschedule_count}}
          </span>
        }
      </div>
    }

    <div class="card-actions" (click)="$event.stopPropagation()">
      <mat-icon [matMenuTriggerFor]="belowMenu">more_vert</mat-icon>
    </div>
    <mat-menu class="cardWithShadow" #belowMenu="matMenu" yPosition="below">
      <button mat-menu-item (click)="editActivty(data())">Edit</button>
      <button mat-menu-item (click)="markCompleted()">{{data()?.completed ? 'Mark As to do' : 'Mark As completed'}}</button>
      <button mat-menu-item (click)="deleteActivity(data()?.id)">Delete</button>
    </mat-menu>
  }
  @if(showFocus()){
    <!-- Focus View - Keep it simple/small as before -->
    <div class="focused-view">
      <div class="row-container">
        <div class="icon">
          <mat-icon style="color:#0a7ea4">{{data()?.type?.icon}}</mat-icon>
        </div>
        <div class="title">
          <span class="title-text" 
            [matTooltip]="data()?.title"
            matTooltipPosition="above"
            [ngClass]="{ 'completed': data()?.completed == true }">
            {{ data()?.title | truncate:20:'...' }}
          </span>
          @if(data()?.merged_from_lead_id){
            <span class="merged-circle" matTooltip="Moved from merge" matTooltipPosition="above">M</span>
          }
        </div>
        <div class="checkbox" (click)="onCheckboxClick($event)">
          <mat-checkbox 
            [checked]="data()?.completed"
            (change)="onCheckboxChange($event)"
            (click)="onCheckboxClick($event)">
          </mat-checkbox>
        </div>
      </div>
      <div class="focused-date">
        <span
          [ngClass]="{
            'overdue-date': isOverdue(data()?.startDate, data()?.allDay) && !data()?.completed,
            'today-date': isToday(data()?.startDate) && !isOverdue(data()?.startDate, data()?.allDay) && !data()?.completed
          }"
        >{{data()?.startDate | customDate}} </span>
      </div>
    </div>
  }
</div>